import React from "react";

export default function Event(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15.966" height="12.772">
			<path
				d="M14.369 6.386a1.6 1.6 0 0 1 1.6-1.6V1.6a1.6 1.6 0 0 0-1.6-1.6H1.6A1.594 1.594 0 0 0 .008 1.6v3.19A1.6 1.6 0 0 1 0 7.983v3.193a1.6 1.6 0 0 0 1.6 1.6h12.769a1.6 1.6 0 0 0 1.6-1.6V7.983a1.6 1.6 0 0 1-1.6-1.597Zm-3.528 3.832L7.983 8.382l-2.858 1.836.862-3.289-2.626-2.147 3.385-.2 1.237-3.145L9.212 4.59l3.385.2-2.626 2.147.87 3.281Z"
				fill="#d7a44d"
			/>
		</svg>
	);
}

export function EventLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="80" height="64">
			<path
				d="M72 32a8.024 8.024 0 0 1 8-8V8a8.024 8.024 0 0 0-8-8H8A7.989 7.989 0 0 0 .04 8v16A8 8 0 0 1 0 40v16a8.024 8.024 0 0 0 8 8h64a8.024 8.024 0 0 0 8-8V40a8.024 8.024 0 0 1-8-8ZM54.32 51.2 40 42l-14.32 9.2L30 34.72 16.84 23.96l16.96-1L40 7.2 46.16 23l16.96 1-13.16 10.76 4.36 16.44Z"
				fill="#d7a44d"
			/>
		</svg>
	);
}
